<template>
  <div class="fixedtoi">
    <!-- Header réseaux sociaux + recherche -->
<header class="d-flex align-items-center justify-content-end"
  style="padding-right: 50px; background-color: #5e840c; height: 50px; color: white;">

  <!-- Téléphone (clic direct) -->
  <a href="tel:+33637281239" style="color: white; text-decoration: none; margin-right: 20px;">
    <i class="fas fa-phone-alt" style="margin-right: 8px;"></i>
    <strong>06 50 58 30 42</strong>
  </a>

  <!-- Réseaux sociaux -->
  <a href="https://www.facebook.com/dogparadiseardeche/"
     target="_blank"
     style="color: white; text-decoration: none; margin-right: 30px;">
    <i class="fab fa-facebook-f"></i>
  </a>
</header>

    <!-- NAVBAR -->
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          <img :src="'https://admin.asso-refuge.fr/images/' + informations.logo" :alt="informations.title" width="75" />
          {{ informations.title }}
        </a>

        <button class="navbar-toggler" type="button" @click="toggleNavbar">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div :class="['collapse', 'navbar-collapse', { show: !isCollapsed }]">

          <!-- Menu -->
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <router-link class="nav-link" to="/qui-sommes-nous" @click="toggleNavbar">Qui sommes-nous</router-link>
            </li>

            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">Nos animaux</a>
              <ul class="dropdown-menu">
                <li>
                  <router-link class="dropdown-item" :to="{ path: '/animaux', query: { type: 'chien' }}" @click="toggleNavbar">Chiens</router-link>
                </li>
                <li>
                  <router-link class="dropdown-item" :to="{ path: '/animaux', query: { type: 'chat' }}" @click="toggleNavbar">Chats</router-link>
                </li>
              </ul>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" to="/sos"  @click="toggleNavbar">S.O.S</router-link>
            </li>

           <li class="nav-item">
                  <router-link class="nav-link" to="/page/19" @click="toggleNavbar">Croc Ardèche</router-link>
            </li>

                

            <li class="nav-item">
              <router-link class="nav-link" to="/animaux_trouve"  @click="toggleNavbar">Fourrière</router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" to="/partenaires"  @click="toggleNavbar">Nos partenaires</router-link>
            </li>

           <li class="nav-item">
              <router-link class="nav-link" to="/adopte"  @click="toggleNavbar">Adoptés</router-link>
            </li>

            <li class="nav-item">
              <router-link class="nav-link" to="/besoins" @click="toggleNavbar" >Nos besoins</router-link>
            </li>
            <li class="nav-item"><router-link class="nav-link" to="/actualites" @click="toggleNavbar" >Actualités</router-link></li>
          </ul>
        </div>
      </div>
    </nav>
  </div>

  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      informations: {},
      isCollapsed: true,
      search: '',
      animaux: [],
      news: [],
      searchResults: [],
    }
  },

  mounted() {
    const idSite = this.$idSite

    fetch(`https://admin.asso-refuge.fr/getInformations/${idSite}`)
      .then(r => r.json())
      .then(data => this.informations = data[0] || {})

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(r => r.json())
      .then(data => this.animaux = data || [])

    fetch(`https://admin.asso-refuge.fr/getNews/${idSite}`)
      .then(r => r.json())
      .then(data => this.news = data || [])

    // Fermer dropdown quand on clique en dehors
    document.addEventListener('click', this.closeSearch)
  },

  beforeUnmount() {
    document.removeEventListener('click', this.closeSearch)
  },

  methods: {
    toggleNavbar() {
      this.isCollapsed = !this.isCollapsed
    },

    objectContains(obj, query) {
      return Object.values(obj).some(value => {
        if (!value) return false
        if (typeof value === 'string') return value.toLowerCase().includes(query)
        if (typeof value === 'object') return this.objectContains(value, query)
        return false
      })
    },

    onSearch() {
      const q = this.search.toLowerCase().trim()

      if (!q || q.length < 2) {
        this.searchResults = []
        return
      }

      // Animaux
      const animalsResults = this.animaux
        .filter(a =>
          a.name?.toLowerCase().includes(q) ||
          a.sexe?.toLowerCase().includes(q) ||
          a.couleur?.toLowerCase().includes(q) ||
          a.race?.toLowerCase().includes(q)
        )
        .map(a => ({
          uid: 'animal-' + a.id,
          id: a.id,
          title: a.name || 'Animal',
          type: 'animal'
        }))

      // Actualités
      const newsResults = this.news
        .filter(n => this.objectContains(n, q))
        .map(n => ({
          uid: 'news-' + n.id,
          id: n.id,
          title: n.nom || 'Actualité',
          type: 'news'
        }))

      this.searchResults = [...animalsResults, ...newsResults].slice(0, 10)
    },

    goToResult(result) {
      this.search = ''
      this.searchResults = []

      if (result.type === 'animal') this.$router.push(`/animaux/${result.id}`)
      if (result.type === 'news') this.$router.push(`/publication/${result.id}`)

      this.isCollapsed = true
    },

    closeSearch(e) {
      if (!e.target.closest('form')) this.searchResults = []
    }
  }
}
</script>

<style src="../assets/css/refonte.css"></style>
